import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import headerLog from "../../../images/khatri_new_logo.svg";
import HeaderSvg from "../../Helpers/HeaderSvg";
import {
  FaHome,
  FaInfoCircle,
  FaChartBar,
  FaGamepad,
  FaFileContract,
  FaTimes,
  FaArrowRight,
  FaChevronRight,
} from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Lock body scroll only when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      <div className="app-container">
        <div className="banner-section ">
          <div className="header-container">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid header-content-main">
                <Logo />

                {/* Mobile Hamburger Toggle Button */}
                <button
                  className="navbar-toggler navbar-toggler-btn custom-toggler"
                  type="button"
                  onClick={() => setIsOpen(!isOpen)}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                {/* Desktop Navigation Links */}
                <div className="d-none d-lg-flex custome-nav">
                  <div className="navigation-links responsive_Nav">
                    <NavigationLinks />
                    <div className="download-btn ">
                      <DownloadButton />
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>

      {/* Ultra-Modern Mobile Menu Drawer & Blurred Backdrop */}
      {isOpen && (
        <>
          <div
            className="mobile-nav-backdrop"
            onClick={() => setIsOpen(false)}
          />
          <div className="mobile-nav-drawer">
            {/* Drawer Header */}
            <div className="mobile-nav-header">
              <Link to="/" onClick={() => setIsOpen(false)}>
                <img
                  src={headerLog}
                  alt="Khatri555"
                  className="mobile-nav-logo"
                />
              </Link>
              <button
                type="button"
                className="mobile-nav-close-btn"
                onClick={() => setIsOpen(false)}
                aria-label="Close menu"
              >
                <FaTimes />
              </button>
            </div>

            <div className="mobile-nav-divider" />

            {/* Nav Links with Theme Icons */}
            <div className="mobile-nav-links">
              <Link
                to="/"
                className={`mobile-nav-item ${
                  location.pathname === "/" ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <div className="mobile-nav-item-left">
                  <span className="mobile-nav-icon">
                    <FaHome />
                  </span>
                  <span className="mobile-nav-label">Home</span>
                </div>
                <FaChevronRight className="mobile-nav-arrow" />
              </Link>

              <Link
                to="/about-us"
                className={`mobile-nav-item ${
                  location.pathname === "/about-us" ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <div className="mobile-nav-item-left">
                  <span className="mobile-nav-icon">
                    <FaInfoCircle />
                  </span>
                  <span className="mobile-nav-label">About Us</span>
                </div>
                <FaChevronRight className="mobile-nav-arrow" />
              </Link>

              <Link
                to="/charts"
                className={`mobile-nav-item ${
                  location.pathname === "/charts" ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <div className="mobile-nav-item-left">
                  <span className="mobile-nav-icon">
                    <FaChartBar />
                  </span>
                  <span className="mobile-nav-label">Charts</span>
                </div>
                <FaChevronRight className="mobile-nav-arrow" />
              </Link>

              <Link
                to="/how-to-play"
                className={`mobile-nav-item ${
                  location.pathname === "/how-to-play" ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <div className="mobile-nav-item-left">
                  <span className="mobile-nav-icon">
                    <FaGamepad />
                  </span>
                  <span className="mobile-nav-label">How To Play</span>
                </div>
                <FaChevronRight className="mobile-nav-arrow" />
              </Link>

              <Link
                to="/terms-conditions"
                className={`mobile-nav-item ${
                  location.pathname === "/terms-conditions" ? "active" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                <div className="mobile-nav-item-left">
                  <span className="mobile-nav-icon">
                    <FaFileContract />
                  </span>
                  <span className="mobile-nav-label">Terms & Condition</span>
                </div>
                <FaChevronRight className="mobile-nav-arrow" />
              </Link>
            </div>

            {/* Bottom CTA Button */}
            <div className="mobile-nav-footer">
              <button
                type="button"
                className="mobile-nav-cta-btn"
                onClick={(e) => {
                  download(e);
                  setIsOpen(false);
                }}
              >
                <span>Get Free App</span>
                <FaArrowRight className="ms-2" />
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const Logo = () => {
  return (
    <Link className="nav-link active" aria-current="page" to="/">
      <img
        className="logo_navbar img-fluid"
        src={headerLog}
        alt="https://khatri555.com/Logo"
      />
    </Link>
  );
};

const NavigationLinks = () => {
  const location = useLocation();

  useEffect(() => {
    const getId = document.getElementById("Title");

    if (getId) {
      if (location.pathname === "/") {
        getId.innerText =
          "Khatri555 | Official & No.1 Online Matka Application in India";
      } else {
        getId.innerText = `Khatri555 | ${location.pathname
          .slice(1, location.pathname.length)
          .toLocaleUpperCase()}`;
      }
    }
  }, [location]);

  return (
    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
      <li className="nav-item">
        <Link className="nav-link d-flex flex-column" aria-current="page" to="/">
          Home
          <HeaderSvg />
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link d-flex flex-column" to="/about-us">
          About Us
          <HeaderSvg />
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link d-flex flex-column" to="/charts">
          Charts
          <HeaderSvg />
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link d-flex flex-column" to="/how-to-play">
          How To Play
          <HeaderSvg />
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link d-flex flex-column" to="/terms-conditions">
          Terms & Condition
          <HeaderSvg />
        </Link>
      </li>
    </ul>
  );
};

const download = async (e) => {
  if (e && e.preventDefault) {
    e.preventDefault();
  }

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

const DownloadButton = () => {
  return (
    <button onClick={download}>
      Get Free App <i className="fa fa-arrow-right" aria-hidden="true"></i>
    </button>
  );
};

export default Navbar;
